import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconEdit.tsx
const IconEdit = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M6.414 16 16.556 5.858l-1.414-1.414L5 14.586V16zm.829 2H3v-4.243L14.435 2.322a1 1 0 0 1 1.414 0l2.829 2.83a1 1 0 0 1 0 1.413zM3 20h18v2H3z"
	})]
});
var IconEdit_default = forwardRef(IconEdit);
//#endregion
export { IconEdit_default as default };
